// extracted by mini-css-extract-plugin
export var actions = "_22-0";
export var actionsContainer = "_22-7";
export var border = "_22-1";
export var childFullHeight = "_22-f";
export var collapse = "_22-2";
export var content = "_22-a";
export var contentChild = "_22-e";
export var fullscreen = "_22-c";
export var hasLeftRadius = "_22-k";
export var headerContainer = "_22-3";
export var headerRow = "_22-5";
export var hidePadding = "_22-b";
export var navCollapsedGap = "_22-l";
export var noScrollX = "_22-m";
export var noScrollY = "_22-n";
export var noTopPadding = "_22-i";
export var optOutTopPadding = "_22-d";
export var pageMain = "_22-j";
export var pageOuter = "_22-g";
export var pagePadding = "_22-8";
export var pageScroll = "_22-9";
export var profile = "_22-o";
export var profileContainer = "_22-p";
export var profileImage = "_22-q";
export var profileMain = "_22-r";
export var profileSubtitle = "_22-t";
export var profileTitle = "_22-s";
export var showLeftPadding = "_22-h";
export var tabsPortalSlot = "_22-6";
export var tabsWrapper = "_22-4";
export var title = "_22-u";